export default {
  identification: 'Identifizierung',
  country: 'Land',
  department: 'Abteilung',
  description: 'Beschreibung',
  charge: 'Standpunkt',
  screen: 'Bildschirm'
}
